import { Product } from "@brunsker/libs/portal-do-vendedor/ui/product-card";

export const PRICE_FILTERS: {
  [key: string]: {
    RANGE_PRECO: number;
    PRECO_INICIAL: number;
    PRECO_FINAL: number;
  };
} = {
  'Até R$ 100': {
    RANGE_PRECO: 1,
    PRECO_INICIAL: 0,
    PRECO_FINAL: 100,
  },
  'R$ 100 - R$ 200': {
    RANGE_PRECO: 1,
    PRECO_INICIAL: 100,
    PRECO_FINAL: 200,
  },
  'R$ 200 - R$ 500': {
    RANGE_PRECO: 1,
    PRECO_INICIAL: 200,
    PRECO_FINAL: 500,
  },
  'R$ 500 - R$ 1000': {
    RANGE_PRECO: 1,
    PRECO_INICIAL: 500,
    PRECO_FINAL: 1000,
  },
  'R$ 1000 - R$ 2000': {
    RANGE_PRECO: 1,
    PRECO_INICIAL: 1000,
    PRECO_FINAL: 2000,
  },
  'Acima de R$ 2000': {
    RANGE_PRECO: 1,
    PRECO_INICIAL: 2000,
    PRECO_FINAL: 999999,
  },
};
export const ORDER_FILTERS: {
  [key: string]: {
    ORDER_AZ: number;
    ORDER_ZA: number;
    ORDER_PRECO_MAIOR: number;
    ORDER_PRECO_MENOR: number;
  };
} = {
  'A - Z': {
    ORDER_AZ: 1,
    ORDER_ZA: 0,
    ORDER_PRECO_MAIOR: 0,
    ORDER_PRECO_MENOR: 0,
  },
  'Z - A': {
    ORDER_AZ: 0,
    ORDER_ZA: 1,
    ORDER_PRECO_MAIOR: 0,
    ORDER_PRECO_MENOR: 0,
  },
  'Maior preço': {
    ORDER_AZ: 0,
    ORDER_ZA: 0,
    ORDER_PRECO_MAIOR: 1,
    ORDER_PRECO_MENOR: 0,
  },
  'Menor preço': {
    ORDER_AZ: 0,
    ORDER_ZA: 0,
    ORDER_PRECO_MAIOR: 0,
    ORDER_PRECO_MENOR: 1,
  },
  '': {
    ORDER_AZ: 1,
    ORDER_ZA: 0,
    ORDER_PRECO_MAIOR: 0,
    ORDER_PRECO_MENOR: 0,
  },
};

export const ORDENAR_FILTERS_PREDICATES: {
  [key: string]: (product: Product[]) => Product[];
} = {
  'Menor preço': (products: Product[]) => {
    return products.sort(
      (firstProduct, secondProduct) =>
        firstProduct.newPrice - secondProduct.newPrice
    );
  },

  'A - Z': (products: Product[]) => {
    return products.sort((firstProduct, secondProduct) => {
      if (firstProduct.name > secondProduct.name) {
        return -1;
      }
      if (firstProduct.name < secondProduct.name) {
        return 1;
      }
      return 0;
    });
  },

  'Z - A': (products: Product[]) => {
    return products.sort((firstProduct, secondProduct) => {
      if (firstProduct.name < secondProduct.name) {
        return -1;
      }
      if (firstProduct.name > secondProduct.name) {
        return 1;
      }
      return 0;
    });
  },

  'Maior preço': (products: Product[]) => {
    return products.sort(
      (firstProduct, secondProduct) =>
        secondProduct.newPrice - firstProduct.newPrice
    );
  },
};

export const PRECO_FILTERS_PREDICATES: {
  [key: string]: (product: Product[]) => Product[];
} = {
  'Até R$ 100': (products: Product[]) => {
    return products.filter((product) => product.newPrice <= 100);
  },

  'R$ 100 - R$ 200': (products: Product[]) => {
    return products.filter(
      (product) => product.newPrice > 100 && product.newPrice <= 200
    );
  },

  'R$ 200 - R$ 500': (products: Product[]) => {
    return products.filter(
      (product) => product.newPrice > 200 && product.newPrice <= 500
    );
  },

  'R$ 500 - R$ 1000': (products: Product[]) => {
    return products.filter(
      (product) => product.newPrice > 500 && product.newPrice <= 1000
    );
  },

  'R$ 1000 - R$ 2000': (products: Product[]) => {
    return products.filter(
      (product) => product.newPrice > 1000 && product.newPrice <= 2000
    );
  },

  'Acima de R$ 2000': (products: Product[]) => {
    return products.filter((product) => product.newPrice > 2000);
  },
};

export const replaceDepartamento = (departamento: string) => {
  const removeNumbersInDepartamento = departamento.replace(/[0-9]/g, '');
  const removeDashAndSpaceInDepartamento = removeNumbersInDepartamento.replace(
    /[-\s]/g,
    ''
  );
  return removeDashAndSpaceInDepartamento;
};
